
































































































































































































































import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import _ from "lodash";
import { DxButton } from "devextreme-vue/ui/button";
import DButton from '@/components/DButton/button.vue';
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import DxSelectBox from 'devextreme-vue/select-box';
import DxPopup from "devextreme-vue/popup";
import DTextbox from "@/components/DTextbox/textbox.vue";
import DTagbox from "@/components/DTagbox/tagbox.vue";
import DxScrollView from 'devextreme-vue/scroll-view';
import DNumberbox from "@/components/DNumberbox/numberbox.vue"
import { DxCheckBox } from "devextreme-vue/check-box";
import { CutType, Tariff, YearType, EcoFilialNodesFlatType, EcoObjectType, AllowedCut, IndexCommonData } from "@/services/models-service";
import TariffService from "@/services/tariff-service";
import YearService from "@/services/years-service";
import CutService from "@/services/cut-service";
import {alert} from 'devextreme/ui/dialog';
import EcoObjectsService from "@/services/eco-objects-service";
import TreeDropDownBox from "@/components/TreeDropDownBox/tree-drop-down-box.vue";
import {numeralForm} from "@/utils/numbers";
import AnimatePopup from '@/components/AnimatePopup/animate-popup.vue';


@Component({
  name: "TariffPopup",
  components: {
    TreeDropDownBox,
    DxButton,
    DSelectbox,
    DxPopup,
    DTextbox,
    DxCheckBox,
    DTagbox,
    DButton,
    DxScrollView,
    DNumberbox,
    DxSelectBox,
    AnimatePopup,
  }
})
export default class extends Vue {
@PropSync('popupOptions') public localPopupOptions: any;
@Prop() public current_year!: string
@Prop() public current_cut!: string

public all_years: YearType [] = [];
public cutsInitialData: CutType[] = [];
public cutsFinalData: AllowedCut[] = [];
public cutsCopy: CutType[] = [];
public all_filials_and_nodes: EcoFilialNodesFlatType[] = [];
public allTariffs: Tariff [] = [];
private allData: any = {};
public checkAllFilials: boolean = false;
public isLoad:boolean = false;
public initialDataCount: number = 0;
public finalDataCount: number = 0;
public filialCheck: boolean = false;
public initialData: IndexCommonData = new IndexCommonData()
public finalData: IndexCommonData = new IndexCommonData()
public settings: any = {
    allGroup: false,
    transport: false,
    price: false,
    tariff: false,
    water: false,
    steam: false,
    signInternalTurnover: false,
    vgo: false,
    vno: false,
    collector: false,
    warm: false,
    revenue: false,
    expenses: false
}

public selectionBlock: any = [];
public indexBlock: any = {
    warmEnergy: 1,
    warmPower: 1,
}

  // Флаг, говорящий не реагировать на изменение выбранного филиала
  private selectionForbidMode = false;
  private stopWatchAllSelection = false;
  private stopWatchNodesSelection = false;
  private stopWatchFilialsSelection = false;
  private selectAllCheckbox = false;

  public isSave:boolean = false;

  public get copyAnimatePopupOptions() {
    return {
      visible: this.isSave,
      text: 'Идёт индексация цен/тарифов...'
    }
}


async created() {

}

async getFilialNodesTree() {

  if (_.isNil(this.initialData.year) || _.isNil(this.initialData.cut)) {
    return
  }

  const year = this.all_years.find((x) => {
    return x.id === this.initialData.year
  })

  const cut = this.cutsInitialData.find((x: any) => {
    return x.id === this.initialData.cut
  })

  if (!year || !cut) {
    return
  }

  this.all_filials_and_nodes = [];
  this.selectionBlock = [];

  const response = await EcoObjectsService.get_filial_nodes_flat(cut.id_eco_version, year.name);

  if (response.data) {
    this.all_filials_and_nodes = response.data;
  }

  this.all_filials_and_nodes.forEach((filial_and_nodes:EcoFilialNodesFlatType) => {
    const index = this.selectionBlock.findIndex((f:any) => f.name === filial_and_nodes.filial_name);

    if (index === -1) {
      this.selectionBlock.push({
        id: filial_and_nodes.filial_id,
        check: false,
        name: filial_and_nodes.filial_name,
        nodes: []}
      )
      this.selectionBlock[this.selectionBlock.length-1].nodes.push({id: filial_and_nodes.id, check: false, name: filial_and_nodes.name});
    } else {
      this.selectionBlock[index].nodes.push({id: filial_and_nodes.id, check: false, name: filial_and_nodes.name});
    }
  })
}

  async mounted() {

  }

async onShowing() {
    this.all_years = YearService.YearList;
    if(this.current_year) {
        this.initialData.year = this.current_year;
    }
    await this.getCutsInitialData();
    if (this.cutsInitialData.length > 0) {
        this.initialData.cut = this.current_cut;
    }
    this.isLoad = true;
}


async getCutsInitialData() {
    const response = await CutService.getWithFilter(this.initialData.year);
    if (response.data) {
        this.cutsInitialData = response.data;
    }
}

async getCutsFinalData() {

  let exist_selected = false;
  for (const i of this.selectionBlock) {
    if (exist_selected) {
      break
    }

    if (i.check) {
      exist_selected = true;
    }

    for (const n of i.nodes) {
      if (n.check) {
        exist_selected = true;
        break
      }
    }
  }

  if (!exist_selected) {
    this.filialCheck = false;
    return
  }

  this.filialCheck = true;

    const cut = this.cutsInitialData.find((x: CutType) => x.id === this.initialData.cut);
    if (!cut) {
      return
    }

    const response = await CutService.getAllowedCuts(cut.id_eco_version, this.finalData.year, this.initialData.cut, this.selectionBlock);

    if (response?.data) {
        this.cutsFinalData = response.data;
    }
}

checkCut(e: any) {
    const cut = this.cutsFinalData.find((c:AllowedCut) => c.id === e.value);
    if (cut?.is_allow === false) {
        alert("Список цен/тарифов не совпадает с выбранной исходной срезкой", 'Ошибка');
        Vue.nextTick(() => {
            this.finalData.cut = '';
        })
    }
}

changeInitialDataCount() {
    this.initialDataCount = 0;

    if (this.initialData.january) this.initialDataCount += 1;
    if (this.initialData.february) this.initialDataCount += 1;
    if (this.initialData.march) this.initialDataCount += 1;
    if (this.initialData.april) this.initialDataCount += 1;
    if (this.initialData.may) this.initialDataCount += 1;
    if (this.initialData.june) this.initialDataCount += 1;
    if (this.initialData.july) this.initialDataCount += 1;
    if (this.initialData.august) this.initialDataCount += 1;
    if (this.initialData.september) this.initialDataCount += 1;
    if (this.initialData.october) this.initialDataCount += 1;
    if (this.initialData.november) this.initialDataCount += 1;
    if (this.initialData.december) this.initialDataCount += 1;

    if (this.initialDataCount === 0) {
        this.finalData.january = this.finalData.february = this.finalData.march = this.finalData.april = this.finalData.may = this.finalData.june =
        this.finalData.july = this.finalData.august = this.finalData.september = this.finalData.october = this.finalData.november = this.finalData.december = false;
    }
    if (this.initialDataCount > 1) {
        this.finalData.january = this.initialData.january;
        this.finalData.february = this.initialData.february;
        this.finalData.march = this.initialData.march;
        this.finalData.april = this.initialData.april;
        this.finalData.may = this.initialData.may;
        this.finalData.june = this.initialData.june;
        this.finalData.july = this.initialData.july;
        this.finalData.august = this.initialData.august;
        this.finalData.september = this.initialData.september;
        this.finalData.october = this.initialData.october;
        this.finalData.november = this.initialData.november;
        this.finalData.december = this.initialData.december;
    }
}

changeFinalDataCount() {
    this.finalDataCount = 0;
    if (this.finalData.january) this.finalDataCount += 1;
    if (this.finalData.february) this.finalDataCount += 1;
    if (this.finalData.march) this.finalDataCount += 1;
    if (this.finalData.april) this.finalDataCount += 1;
    if (this.finalData.may) this.finalDataCount += 1;
    if (this.finalData.june) this.finalDataCount += 1;
    if (this.finalData.july) this.finalDataCount += 1;
    if (this.finalData.august) this.finalDataCount += 1;
    if (this.finalData.september) this.finalDataCount += 1;
    if (this.finalData.october) this.finalDataCount += 1;
    if (this.finalData.november) this.finalDataCount += 1;
    if (this.finalData.december) this.finalDataCount += 1;
}


async onAccept() {
    this.isSave = true;
    this.allData = {};
    this.allData.initialData = this.initialData;
    this.allData.finalData = this.finalData;
    this.allData.settings = this.settings;
    this.allData.selectionBlock = this.selectionBlock;
    this.allData.indexBlock = this.indexBlock;
    const response = await TariffService.indexData(this.allData);
    if (response.status === "Успех") {
        alert(`Всего тарифов ${response.all_tariffs}. Проиндексировано ${response.index_tariffs}`, 'Успех');
        this.onCancel();
    } else {
        alert(response.status, 'Ошибка');
    }
    this.isSave = false;
}

onCancel() {
    this.isLoad = false;
    this.localPopupOptions.visible = false;
    this.$emit("update_tariffs");
}


onClose() {
    this.isLoad = false;
    this.localPopupOptions.visible = false;
    this.initialData = new IndexCommonData();
    this.finalData = new IndexCommonData();
    this.selectionBlock.forEach((fil: any)=> {
        fil.check = false;
        fil.nodes.forEach((node: any) => {
            node.check = false;
        })
    })

    this.settings = {
        allGroup: false,
        transport: false,
        price: false,
        tariff: false,
        water: false,
        steam: false,
        signInternalTurnover: false,
        vgo: false,
        vno: false,
        collector: false,
        warm: false,
        revenue: false,
        expenses: false
    }

    this.checkAllFilials = false;
    this.indexBlock.warmEnergy = this.indexBlock.warmPower = 1;
}

@Watch("initialData.year")
async changeInitialYear() {
    if (this.isLoad) {
        this.initialData.cut = "";
        await this.getCutsInitialData();
    }
}

@Watch("initialData.cut")
async Cut() {
    if (this.isLoad) {
        this.finalData.cut = "";
        this.getFilialNodesTree();
        if (this.finalData.year && this.initialData.cut) {
          this.getCutsFinalData();
        }
    }
}

@Watch("finalData.year")
async changeFinalYear() {
    if (this.isLoad) {

      this.finalData.cut = "";
        if (this.finalData.year && this.initialData.cut) {
          await this.getCutsFinalData();
        }
    }
}

@Watch("settings.allGroup")
chooseAllGroup() {
    if(this.settings.allGroup) {
        this.settings.transport = false;
    }
}

@Watch("settings.transport")
chooseTransport() {
    if(this.settings.transport) {
        this.settings.allGroup = false;
        this.settings.collector = false;
    } else {
        this.settings.collector = true;
    }
}

@Watch("settings.signInternalTurnover")
clearVnoVgo() {
    if (this.settings.signInternalTurnover) {
        this.settings.vno = this.settings.vgo = false;
    }
}

@Watch("settings.vgo")
@Watch("settings.vno")
clearInternalTurnover() {
    if (this.settings.vno) {
        this.settings.signInternalTurnover = this.settings.collector = this.settings.warm = this.settings.revenue = this.settings.expenses =  false;
    }
    if (this.settings.vgo) {
        this.settings.signInternalTurnover = this.settings.collector = this.settings.warm = this.settings.revenue = this.settings.expenses =  false;
    }
}

async onAllSelectionChanged(e: any) {

  if (this.stopWatchAllSelection) {
    return
  }

  this.stopWatchNodesSelection = true;
  this.stopWatchFilialsSelection = true;

  for (const s of this.selectionBlock) {
    this.updateFilialCheckState(s.id, e.value);
  }

  this.finalData.cut = "";
  if (this.finalData.year && this.initialData.cut) {
    this.getCutsFinalData();
  }

  Vue.nextTick(() => {
    this.stopWatchNodesSelection = false;
    this.stopWatchFilialsSelection = false;
  })

}

  private updateFilialCheckState(filialId: number, value: boolean) {
    const s = this.selectionBlock.find( (sb: any) => sb.id === filialId);
    if (s) {
      this.stopWatchNodesSelection = true;
      this.stopWatchAllSelection = true;

      s.check = value;
      for (let n of s.nodes) {
        n.check = value
      }

      this.checkAllFilials = _.every(this.selectionBlock, (x: any) => x.check);

      Vue.nextTick(() => {
        this.stopWatchNodesSelection = false;
        this.stopWatchAllSelection = false;
      })
    }
  }

  onFilialCheckChanged(filialId: number, e: any) {

    if (this.stopWatchFilialsSelection) {
      return
    }

    this.updateFilialCheckState(filialId, e.value)

    this.finalData.cut = "";
    if (this.finalData.year && this.initialData.cut) {
      this.getCutsFinalData();
    }
  }


  onNodeCheckChanged(filialId: number, item: any, e: any) {

    if (this.stopWatchNodesSelection) {
      return
    }

    const s = this.selectionBlock.find( (sb: any) => sb.id === filialId);
    if (s) {
      this.stopWatchFilialsSelection = true;
      this.stopWatchAllSelection = true;

      let all_node_selected = true;

      for (let n of s.nodes) {
        if (n.id === item.id) {
          n.check = e.value
        }
        all_node_selected = all_node_selected && n.check;
      }

      if (s.check !== all_node_selected) {
        s.check = all_node_selected;

        this.checkAllFilials = _.every(this.selectionBlock, (x: any) => x.check);
      }


      Vue.nextTick(() => {
        this.stopWatchFilialsSelection = false;
        this.stopWatchAllSelection = false;
      })
    }

    this.finalData.cut = "";
    if (this.finalData.year && this.initialData.cut) {
      this.getCutsFinalData();
    }
  }

}
